module.exports = __webpack_public_path__ + "static/omoniyi-8985ef86c7c201932be93a50956c7984.jpg";